import RemainingTimeComponent from "@/main/components/shared/remainingTime/remainingTimeComponent";
import TooltipComponent from "@/main/components/shared/tooltip/tooltipComponent";
import { getTranslateByKey } from "@/main/services/utils";

interface IPendingDeadlineCellProps {
	deadlineAnswer: string | null;
	onTimeFinished: () => void;
}

const TOOLTIP_MAX_WIDTH = 260;

export default function PendingDeadlineCell({ deadlineAnswer, onTimeFinished }: IPendingDeadlineCellProps) {
	if (deadlineAnswer) {
		return <RemainingTimeComponent finishTime={deadlineAnswer} onTimeFinished={onTimeFinished} />;
	}

	return (
		<TooltipComponent
			title={
				<div style={{ maxWidth: TOOLTIP_MAX_WIDTH, wordBreak: "normal" }}>
					{getTranslateByKey("information.selfSuppliedNoDeadline")}
				</div>
			}
			placement="top"
			enterTouchDelay={0}
		>
			{/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- focusable so the tooltip opens on keyboard focus */}
			<span tabIndex={0} style={{ display: "inline-block", outline: "none" }}>
				{getTranslateByKey("information.notApplicable")}
			</span>
		</TooltipComponent>
	);
}
